var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgClaims = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 26 26"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#86A7B2",
  d: "M19.3 22.7H7.6v-1h10.7v-1.4h1zM6.7 19.2c-.3 0-.5-.2-.5-.5V5.4c0-1.1.9-2 2-2h11v11c0 .3-.2.5-.5.5s-.5-.2-.5-.5v-10h-10c-.6 0-1 .5-1 1v13.3c0 .2-.2.5-.5.5"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#86A7B2",
  d: "M17.4 22.7h-.1c-2.6-.6-3.1-2.1-3.4-3 0-.1-.1-.3-.1-.4s-.2-.2-.3-.2H4.6c0 .4.1 1.1.5 1.6s1.1.9 2.1.9h.6c.3 0 .5.2.5.5s-.2.5-.5.5h-.6c-1.3-.1-2.3-.5-2.9-1.3-.9-1.2-.6-2.7-.6-2.8l.1-.4h9.7c.5 0 1 .3 1.2.8.1.1.1.3.2.4.3.8.6 1.9 2.7 2.3.3.1.4.3.4.6-.1.3-.3.5-.6.5M22.4 7.7h-3.6c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h2.6c-.1-.8-.5-2.3-2.4-2.4h-.6c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h.6c1.1.1 1.9.4 2.5 1.1 1 1.1.9 2.7.9 2.8z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#42A5F2",
  d: "M17 19.6 15.4 18c-.2-.2-.2-.5 0-.7s.5-.2.7 0l.8.8 3.2-3.6c.2-.2.5-.2.7 0s.2.5 0 .7zM18.6 18.6l-.8.9h3.1v-.9z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#D5EBEF",
  d: "M10.7 14c-.3 0-.5-.2-.5-.5v-.7H9.1c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h2c.4 0 .7-.3.7-.7s-.3-.7-.7-.7h-.8c-.9 0-1.7-.8-1.7-1.7s.7-1.6 1.6-1.7v-.6c0-.3.2-.5.5-.5s.5.2.5.5v.7h1.1c.3 0 .5.2.5.5s-.2.5-.5.5h-2c-.4 0-.7.3-.7.7s.3.7.7.7h.8c.9 0 1.7.8 1.7 1.7s-.7 1.6-1.6 1.7v.7c0 .2-.3.4-.5.4"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#86A7B2",
  d: "M18.3 14.2v1.5l.9-.9v-1z"
})));
export default SvgClaims;